import React from 'react';
import PhonicsAtoZ from './PhonicsAtoZ';
import letterDataKk from './phonics/phonics_data_kk';

function PhonicsKk() {
  return <PhonicsAtoZ letterData={letterDataKk} />;
}

export default PhonicsKk;
